export default __webpack_public_path__ + "static/media/sage-green.150a2375.webp";